<div class="container-fluid">
  <br />
  <div class="mx-auto" *ngIf="loading">
    <div class="d-flex justify-content-center">
      <strong></strong>
    </div>
    <div class="d-flex justify-content-center">
      <strong>Espere un momento mientras se carga la información ...
        <div class="spinner-border" role="status"></div>
      </strong>
    </div>
  </div>
  <div *ngIf="!loading">
    <!-- <form class="form-inline">
      <div class="form-group mb-2">
        <div class="mb-3">
          <div class="input-group ">
            <span class="input-group-text"  style="color: white; background-color: #004b87" id="basic-addon3">Año</span>
            <select [class]="'form-control'" [(ngModel)]="year" [value]="year" name="year"  (change)="getCapacitaciones()" >
              <option *ngFor="let years of yearsDB" [value]="years">
                {{years}}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="form-group mx-sm-3 mb-2">
        <div class="mb-3">
          <div class="input-group">
            <span class="input-group-text"  style="color: white; background-color: #004b87" id="basic-addon3">Mes</span>
            <select [class]="'form-control'" [(ngModel)]="month" [value]="month" name="month" (change)="getCapacitaciones()" >
              <option value=""> Todos los meses </option>
              <option *ngFor="let months of monthDB" [value]="months.id">
                {{months.label}}
              </option>
            </select>
          </div>
        </div>
      </div>
    </form> -->

      <div *ngIf="!loading">
    <form class="form-inline">
      <!-- Año -->
      <div class="form-group mb-2">
        <div class="mb-3">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text" style="color:#fff;background-color:#004b87" id="addon-year">Año</span>
            </div>
            <select class="custom-select"
                    aria-describedby="addon-year"
                    [(ngModel)]="year"
                    name="year"
                    (change)="getCapacitaciones()">
              <option *ngFor="let y of yearsDB" [value]="y">{{ y }}</option>
            </select>
          </div>
        </div>
      </div>

      <!-- Mes -->
      <div class="form-group mx-sm-3 mb-2">
        <div class="mb-3">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text" style="color:#fff;background-color:#004b87" id="addon-month">Mes</span>
            </div>
            <select class="custom-select"
                    aria-describedby="addon-month"
                    [(ngModel)]="month"
                    name="month"
                    (change)="getCapacitaciones()">
              <option [ngValue]="null">Todos los meses</option>
              <option *ngFor="let m of monthDB" [value]="m.id">{{ m.label }}</option>
            </select>
          </div>
        </div>
      </div>
    </form>
    
    <br />
    <div class="container-fluid">
      <br/>
      <div class="row align-items-start">
        <div class="col-10">
          <div class="col-4">
            <input type="text" [ngModel]="searchT" [class]="'form-control'" placeholder="Filtrar..." id="button-search"
              (keyup)="changeSearch($event)">
          </div>
        </div>

        <!-- Inicio -->

        <!-- <div class="col-2">
          <button type="button" class="btn button-export shadow-none" (click)="export()">
            <img [src]="'assets/icons/excel_black.svg'" style="max-width:35px;"> Exportar
          </button>
          
        </div>  -->
        
        <div class="col-2">
          <div class="dropdown">
            <button
              type="button"
              class="btn button-export shadow-none dropdown-toggle d-flex align-items-center"
              id="exportDropdown"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <img [src]="'assets/icons/excel_black.svg'" style="max-width:35px;" class="mr-2">
              Exportar
            </button>

            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="exportDropdown">
              <button class="dropdown-item" (click)="exports('all')">Todos los registros</button>
              <button class="dropdown-item" (click)="exports('current')">Página actual</button>
              <div class="dropdown-divider"></div>
              <button class="dropdown-item" (click)="exportSpecificPage()">Página específica…</button>
            </div>
          </div>
        </div>


        <!--   FIn -->
      </div>
      <div>
        <div class="row col-12">
          <div class="col-12">
            <table class="table table-striped table-responsive">
  <thead>
    <th>Id</th>
    <th>Zona</th>
    <!-- <th *ngIf="rolid == 1 || rolid == 2">Contratista</th> -->
    <th>Tipo</th>
    <th>Nombre</th>
    <th>Categoría</th>
    <th>Foco</th>
    <th>Ejecutor</th>
    <th>Mes planificación</th>
    <th>Estado</th>
    <th>Acciones</th>
  </thead>

  <tbody *ngIf="rows.length > 0">
    <!-- SIN | paginate: renderiza lo que vino del backend -->
    <tr *ngFor="let row of rows"
        (dblclick)="openEditionModal(capacitacionModal, row.capacitacion, row.workers)">
      <td *ngFor="let cell of row.cells" [class]="cell.class">
        <ng-container *ngIf="cell.tooltip">
          <span [ngbTooltip]="cell.content" placement="left">{{ cell.content }}</span>
        </ng-container>
        <ng-container *ngIf="!cell.tooltip">
          {{ cell.content }}
        </ng-container>
      </td>
      <td class="actions">
        <span class="active"
              (click)="openInformationModal(capacitacionModal, row.capacitacion, row.workers)"
              ngbTooltip="Visualizar">
          <img src="assets/icons/eye.svg" style="max-width:20px;" />
        </span>
        <span class="active"
              (click)="openDeleteModal(confirmationModal, row.capacitacion)"
              ngbTooltip="Eliminar"
              *ngIf="(rolid == 1 || rolid == 2)">
          <img src="assets/icons/trashcan.svg" style="max-width:20px;" />
        </span>
        <span class="active"
              *ngIf="row.status == 'Abierta' || (rolid == 1 || rolid == 2)"
              (click)="openEditionModal(capacitacionModal, row.capacitacion, row.workers)"
              ngbTooltip="Editar">
          <img src="assets/icons/pencil.svg" style="max-width:20px;" />
        </span>
      </td>
    </tr>
  </tbody>

  <tbody *ngIf="rows.length == 0">
    <tr class="td-centered"><td>No se encontraron registros</td></tr>
  </tbody>
</table>


<div class="d-flex justify-content-between align-items-center">
  <ngb-pagination
    [collectionSize]="totalAmmount"   
    [(page)]="page"                  
    [pageSize]="pageSize"            
    [maxSize]="5"
    [rotate]="true"
    [ellipses]="false"
    [boundaryLinks]="true"
    (pageChange)="onPageChange($event)">
  </ngb-pagination>

  <div class="form-inline">
    <label class="mr-2">Filas por página</label>
    <select class="form-control" [(ngModel)]="pageSize" (change)="onPageSizeChange()">
      <option *ngFor="let size of sizeOptions" [value]="size.value">{{ size.label }}</option>
    </select>
  </div>
</div>
          </div>
        </div>
        <br />
        <!-- <div class="row align-items-start" *ngIf="rows.length > 0">
          <div class="col-10">
            <pagination-controls (pageChange)="pageActualFoco = $event" class="pagination"></pagination-controls>
          </div>
          <div class="col-2">
            <select [class]="'form-control'" [(ngModel)]="itemPerPage" [value]="itemPerPage"
              (change)="rerenderCapacitaciones()">
              <option *ngFor="let sizePage of sizeOptions" [value]="sizePage.value">
                {{sizePage.label}}
              </option>
            </select>
          </div>
        </div> -->
      </div>
      <br/>
      <!-- <div *ngIf="filtrando" class="d-flex justify-content-center">
        <strong>Filtrando datos ....</strong>
      </div> -->
    </div>
    <!-- <div class="mx-auto" *ngIf="rows.length == 0">
      <div class="d-flex justify-content-center">
        <strong></strong>
      </div>
      <div class="d-flex justify-content-center">
        <strong>No se encontraron registros</strong>
      </div>
    </div> -->
  </div>
</div>

<!-- <div class="d-flex justify-content-between p-2 pagination">
    <ngb-pagination [collectionSize]="totalAmmount" [page]="page + 1" (pageChange)="onChangePage($event - 1)"
      [pageSize]="pageSize" [maxSize]="1" [rotate]="true" [boundaryLinks]="true"></ngb-pagination>
  
    <div *ngIf="loading" class="spinner-border spinner" role="status">
      <span class="sr-only">Loading...</span>
    </div>
    <select class="custom-select" style="width: auto" name="pageSize" (change)="onChangeSize($event.target.value)">
      <option *ngFor="let option of sizeOptions" [value]="option.value">{{option.label}}</option>
    </select>
  </div> -->


<ng-template #capacitacionModal let-modal>
  <app-capacitacion-modal [modal]="modal" [mode]="capacitacionModalMode" [categoriesWithFocos]="categoriesWithFocos"
    [enfoques]="enfoques" [ejecutoresWithRelatores]="ejecutoresWithRelatores" [capacitacion]="capacitacionSelected"
    [workersIdSelected]="capacitacionSelectedWorkersIds" [workersSelected]="capacitacionSelectedWorkers"
    [confirmationModalOptionLabel]="confirmationModalOptionLabel" [confirmationModalOptions]="confirmationModalOptions"
    [zonas]="zonas" (save)="onChangePage(page)" (accept)="onChangePage(page)" (reject)="onChangePage(page)">
  </app-capacitacion-modal>
</ng-template>

<ng-template #confirmationModal let-modal>
  <app-confirmation-modal [modal]="modal" [tittle]="confirmationModalTittle" [message]="confirmationModalMessage"
    [hasComment]="confirmationModalHasComment" [hasOptions]="confirmationModalHasOptions"
    [isCommentObligatory]="confirmationModalisCommentObligatory" [optionLabel]="confirmationModalOptionLabel"
    [options]="confirmationModalOptions" (accept)="confirmationModalAccept($event.comment, $event.option)">
  </app-confirmation-modal>
</ng-template>